export const common = {
  Start: "Start",
  Download: "Download Full PDF",
  fullPdfReport: "/data/pdf/en/BMW-Group-Bericht-2020-EN.pdf",
  Fullscreen: "Fullscreen",
  Scroll: "Scroll",
  Top: "Top",
  autoplay: "<strong>AUTOPLAY</strong>ca. 90 sec.",
  rotatePhone: "For a better experience turn your mobile",
  pdfLoading: "PDF is loading …",
  pdf_title: "The BMW GROUP<br>REPORT 2020",
  pdf_type: "PDF",
};
